import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import { OpenInNew } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const SpareEdit = ({ match }) => {

    const { id } = useParams(); // Use useParams to get the id from the URL
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        Code: '',
        Description: '',
        HSNCode: '',
        SaleRate: '',
        PurchaseRate: '',
        GSTRate: '',
        OpeningStock: '',
        CurrentStock: '',
        TotalStock: '',
        MinimumStock: '',
        PurchaseRate: '',
        isSubmit: false
    });

    useEffect(() => {
        fetchData('BrandApi', `/SparePartsDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        // if (!formData.isSubmit) {
        //   return;
        // }

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('SparePartsApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SpareIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={handleSubmit}>

                    <div className='w-full mb-2 flex items-center'>
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SPARE PARTS EDIT</h6>

                        <Tooltip title="Exit">
                            <Link to="/SpareIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="Update">

                            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>

                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">



                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Item Name"
                                maxLength={50}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Code"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                HSNCode
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="hsnCode"
                                value={formData.hsnCode}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter HSNCode"
                                maxLength={7}
                            />
                        </div>
                    </div>
                    <div className="w-full mb-4 flex">


                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Description
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Item Name"
                                maxLength={100}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                GST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="gstRate"
                                value={formData.gstRate}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter GST Rate"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                Purchase Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="purchaseRate"
                                value={formData.purchaseRate}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Purchase Rate"
                                maxLength={5}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                Sale Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="saleRate"
                                value={formData.saleRate}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Sale Rate"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                OpenningStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="openingStock"
                                value={formData.openingStock}
                                onChange={handleChange}
                                type="text"
                                placeholder="openning Stock"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                TotalStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="totalStock"
                                value={formData.totalStock}
                                onChange={handleChange}
                                type="text"
                                placeholder="Total stock"
                                maxLength={5}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                CurrentStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="currentStock"
                                value={formData.currentStock}
                                onChange={handleChange}
                                type="text"
                                placeholder="current stock"
                                maxLength={5}
                            />
                        </div>
                        <div className="w-1/8 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
                                MinimumStock
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                name="minimumStock"
                                value={formData.minimumStock}
                                onChange={handleChange}
                                type="text"
                                placeholder="Minimum stock"
                                maxLength={5}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    );
}

export default SpareEdit;

